import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { authorize } from "../../services/auth/reducer";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import LockIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

import Logo from "../../resources/logo.png";
import Colors from "../../constants/Colors";

const styles = theme => ({
  layout: {
    width: "auto",
    display: "block", // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main
  },
  logo: {
    width: "40%",
    marginBottom: 15
    // height: 50,
    // width: 120
  },
  form: {
    width: "100%", // Fix IE11 issue.
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 3
  },
  loginError: {
    backgroundColor: "#FCE6E7",
    borderRadius: 8
  },
  errorText: {
    color: "#e6525a",
    padding: "13px 15px",
    borderRadius: 6,
    backgroundColor: "rgba(230,82,90,0.15)"
  }
});

class Login extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "" };
  }

  onChangeEmail = event => {
    this.setState({ email: event.target.value });
  };

  onChangePassword = event => {
    this.setState({ password: event.target.value });
  };

  onSubmit = () => {
    const { email, password } = this.state;
    this.props.authorize(email, password);
  };

  render() {
    const { error, token, role, classes } = this.props;

    if (token) {
      if (role === "user") {
        return <Redirect to="/team" />;
      }
      return <Redirect to="/" />;
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <img src={Logo} alt="Pulse Logo" className={classes.logo} />
            {/* <Avatar className={classes.avatar} src={Logo} alt="Pulse Logo" /> */}
            <Typography variant="h5" style={{ color: Colors.text }}>
              Se connecter
            </Typography>
            {/* <div className={classes.loginError}> */}
            {/* </div> */}
            <div className={classes.form}>
              {error && <p className={classes.errorText}>{error}</p>}
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="email">Adresse email</InputLabel>
                <Input
                  id="email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  onChange={this.onChangeEmail}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">Mot de passe</InputLabel>
                <Input
                  name="password"
                  type="password"
                  id="password"
                  onChange={this.onChangePassword}
                  autoComplete="current-password"
                />
              </FormControl>
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                style={{ backgroundColor: Colors.main }}
                type="submit"
                fullWidth
                onClick={this.onSubmit}
                variant="contained"
                color="primary"
                className={classes.onSubmit}
              >
                Login
              </Button>
            </div>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  token: state.auth.accessToken,
  role: state.auth.role,
  error: state.auth.error
});

export default connect(
  mapStateToProps,
  { authorize }
)(withStyles(styles)(Login));
// export default withStyles(styles)(SignIn);
